// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-1869b157]{margin-top:.65em!important;font-weight:700!important;font-size:19px!important;line-height:28px!important;color:#080d33!important}", ""]);
// Exports
module.exports = exports;
